import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

const options = {
   theme: {
      dark: false,
      default: 'light',
      options: {
         customProperties: true
      },
      themes: {
         light: {
            primary: '#10498a',
            secondary: '#666',
            accent: '#10498a',
            error: '#f44336',
            warning: '#ff5722',
            info: '#3f51b5',
            success: '#4caf50',
            grey_light: '#f5f5f5',
            grey_dark: '#565656',
            accent_border: '#8c8c8c',
            primary_light: '#1359a9',
            yellow: '#EEFF41',
            orange: '#FB8C00',
         }
      },
   },
   icons: {
      iconfont: 'mdi', // default - only for display purposes
   },
}

export default new Vuetify(options)
